import React, { memo } from 'react';
import { ProgressCard as ProgressCardType, ProgressCardProps } from '../types';
import { DefaultProgressCard } from './DefaultProgressCard';
import { GenerateProgressCard } from './GenerateProgressCard';

export const ProgressCard: React.FC<ProgressCardProps> = memo(({ card, type }) => {
  // Use the type prop if provided, otherwise use card.type
  // Normalize to uppercase for case-insensitive comparison
  const cardType = (type || card.type || 'TARGET').toUpperCase();

  // Render GenerateProgressCard for 'GENERATE' type
  if (cardType === 'GENERATE') {
    return <GenerateProgressCard card={card} />;
  }

  // Render DefaultProgressCard for 'TARGET' type or any other case (default)
  return <DefaultProgressCard card={card} />;
});

// Add display name for debugging
ProgressCard.displayName = 'ProgressCard';

